module.exports = __webpack_public_path__ + "media/images/amenities_icons/skype-272fa4f13af26ea0af100ef62165a77f.svg";